import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Login';
import Register from './Components/Register';
import EditWebhook from './Components/EditWebhook';
import EmailVerification from './util/EmailVerification'; // Импортируем компонент для верификации
import Verify from "./Components/Verify";
import Dashboard from './Components/Dashboard';
import Navbar from './Components/Navbar';
import CreateWebhook from './Components/CreateWebhook';
import UserLogs from './Components/UserLogs';
import WebhookLogs from './Components/WebhookLogs';
import HomePage from './Components/HomePage';
import ForgotPassword from './Components/ForgotPassword';
import ResetPassword from './Components/ResetPassword';
import Profile from "./Components/Profile";


function App() {
  return (
    <Router>
        <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/mail/verify/:token" element={<EmailVerification />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create-webhook" element={<CreateWebhook />} />
        <Route path="/logs" element={<UserLogs />} />
        <Route path="/logs/:webhookId" element={<WebhookLogs />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/edit-webhook/:webhookId" element={<EditWebhook />} />
      </Routes>
    </Router>
  );
}

export default App;